import {derived} from 'svelte/store';

import {bodyTypeFlagsStore} from './body-type-flags-store';

export const bodyTypesStore = derived(
  bodyTypeFlagsStore,
  ($bodyTypeFlagsStore) => {
    const result = [];

    for (const type in $bodyTypeFlagsStore) {
      if ($bodyTypeFlagsStore[type]) {
        result.push(type);
      }
    }

    return result;
  }
);
